import { Box, CircularProgress } from '@mui/material';
import { Button } from '../../../Components/MUIs';

export default function PerButton({
  onCancel,
  onClick,
  cancelText = '취소',
  saveText = '다음',
  cancelColor = '#776D6D',
  saveColor = '#57B84D',
  disabled = false,
  saveDisabled = false,
}) {
  const isSaveDisabled = disabled || saveDisabled;

  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 2, backgroundColor: '#f7f8fa' }}>
      <button
        style={{
          width: '40%',
          height: 36,
          borderRadius: '5px',
          backgroundColor: '#f7f8fa',
          border: `1px solid ${cancelColor}`,
          color: cancelColor,

          boxShadow:
            '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
        }}
        onClick={onCancel}
      >
        {cancelText}
      </button>

      <Button
        name={
          disabled ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
              }}
            >
              <CircularProgress size={16} sx={{ color: '#fff' }} />
              <span>{saveText}</span>
            </Box>
          ) : (
            saveText
          )
        }
        disabled={isSaveDisabled}
        sx={{
          width: '60%',
          height: 36,
          borderRadius: '5px',
          backgroundColor: saveColor,
          color: '#fff',
          opacity: saveDisabled && !disabled ? 0.5 : 1,
          boxShadow:
            '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
        }}
        onClick={onClick}
      />
    </Box>
  );
}
